import { useMutation } from "react-query";
import { post } from "shared/data";
import { setSourcePage } from "components/attributes/lib/attribute-data";

export const useChangeDigitalLite = (sourcePage) => {
    return useMutation((params) => post(`/shipment-type-switching${setSourcePage(sourcePage, true)}`, { ...params, targetShipmentType: 2 }));
};
